<script>
  let h, m;

  const setTime = () => {
    let currentTime = new Date();
    h = currentTime.getHours();
    m = currentTime.getMinutes();
  };
  setTime();

  setInterval(() => {
    setTime();
  }, 1000);
</script>

<span class="time-container"
  >{h.toString().padStart(2, "0")}<span class="anim-blink">:</span
  >{m.toString().padStart(2, "0")}</span
>

<style lang="scss">
  .time-container {
    filter: blur(0.5px);
  }

  .anim-blink {
    animation: 1s linear infinite alternate blink;
    animation-timing-function: cubic-bezier(0.83, 0, 0.17, 1);
  }
  @keyframes blink {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
</style>
